/**
 * Outline icon paths — single graphic language across the design system.
 * Style: 24x24 viewBox, 1.5px stroke, round caps/joins, no fills.
 * Keep every icon inside this registry so nothing else introduces a
 * different icon set or stroke weight.
 */
export const ICON_PATHS = {
    home: "M4 10.5 12 4l8 6.5V19a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z",
    search: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM20 20l-4.35-4.35",
    bell: "M7 10a5 5 0 0 1 10 0v3.5l1.5 2.5h-13l1.5-2.5ZM10 19a2 2 0 0 0 4 0",
    calendar: "M5 8.5h14M8 4v3M16 4v3M6 6.5h12A2 2 0 0 1 20 8.5V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2Z",
    clock: "M12 8v4l2.5 2.5M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
    "check-circle": "M8.5 12.25 11 14.75 16 9.5M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
    "x-circle": "M9.5 9.5l5 5M14.5 9.5l-5 5M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
    x: "M6 6l12 12M18 6 6 18",
    folder: "M4 7a1.5 1.5 0 0 1 1.5-1.5h4l1.8 2H18.5A1.5 1.5 0 0 1 20 9v8a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17Z",
    document: "M8 3.5h6l4 4V19a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1ZM14 3.5V8h4M9.5 12h5M9.5 15h5",
    filter: "M4 5.5h16M7 12h10M10 18.5h4",
    download: "M12 4v11M8 11.5 12 15.5 16 11.5M5 18.5h14",
    upload: "M12 15V4M8 7.5 12 3.5 16 7.5M5 18.5h14",
    refresh: "M4.5 12a7.5 7.5 0 0 1 12.6-5.5M17.5 4.5v3.8h-3.8M19.5 12a7.5 7.5 0 0 1-12.6 5.5M6.5 19.5v-3.8h3.8",
    pencil: "M14.5 5.5 18.5 9.5 8 20H4v-4ZM13 7l4 4",
    trash: "M5 7h14M9.5 7V5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2M7 7l1 12.5A1.5 1.5 0 0 0 9.5 21h5a1.5 1.5 0 0 0 1.5-1.5L17 7",
    user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4.5 20a7.5 7.5 0 0 1 15 0",
    users: "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM2.5 19.5a6.5 6.5 0 0 1 13 0M16.3 4.2a3.5 3.5 0 0 1 0 6.6M18.5 13.3a6.5 6.5 0 0 1 3.5 6.2",
    mail: "M4.5 6.5h15A1 1 0 0 1 20.5 7.5v9a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1ZM4.8 7 12 12.5 19.2 7",
    settings: "M9 12a3 3 0 1 0 6 0 3 3 0 1 0-6 0M19.5 12h2M15.8 18.5l1 1.7M8.3 18.5l-1 1.7M4.5 12h-2M8.3 5.5l-1-1.7M15.8 5.5l1-1.7",
    "help-circle": "M9.5 9a2.5 2.5 0 1 1 4 2c-.7.55-1.5.9-1.5 2M12 16.5h.01M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
    info: "M12 8h.01M11.25 11h.75v5h.75M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
    "alert-triangle": "M12 9v4M12 16.5h.01M10.9 4.6 3.4 18a1.2 1.2 0 0 0 1 1.8h15.2a1.2 1.2 0 0 0 1-1.8L13.1 4.6a1.2 1.2 0 0 0-2.2 0Z",
    check: "M5 12.5 9.5 17 19 6.5",
    plus: "M12 5v14M5 12h14",
    minus: "M5 12h14",
    "chevron-down": "M6 9.5 12 15l6-5.5",
    "chevron-right": "M9.5 6 15 12l-5.5 6",
    "chevron-left": "M14.5 6 9 12l5.5 6",
    "arrow-right": "M4.5 12h15M13.5 6l6 6-6 6",
    "more-horizontal": "M5 12h.01M12 12h.01M19 12h.01",
    logout: "M9 8V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-2M14 12H3M6.5 8.5 3 12l3.5 3.5",
    sun: "M12 5.5V3M12 21v-2.5M5.5 12H3M21 12h-2.5M6.4 6.4 4.7 4.7M19.3 19.3l-1.7-1.7M6.4 17.6l-1.7 1.7M19.3 4.7l-1.7 1.7M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    moon: "M20 14.2A8.2 8.2 0 1 1 9.8 4 6.6 6.6 0 0 0 20 14.2Z",
};
//# sourceMappingURL=icons.js.map